import { useQuery } from "@tanstack/react-query";
import { getStaticPage } from "../services/staticPagesService";
import { QUERY_KEYS, QUERY_CONFIG, STATIC_PAGE_TYPE } from "../../../core/config/Constant";

// Social + contact values surfaced site-wide (e.g. footer).
const CONFIG_TYPES = [
  STATIC_PAGE_TYPE.EMAILS,
  STATIC_PAGE_TYPE.CONTACT_NUMBER,
];

/**
 * Fetches all social/contact config values once per session, in parallel.
 * @returns {{ instagram, twitter, facebook, threads, linkedin, youtube, emails, address, contact_number }}
 */
export const useSiteConfig = (options = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.SITE_CONFIG],
    queryFn: async () => {
      const results = await Promise.allSettled(CONFIG_TYPES.map(getStaticPage));
      return CONFIG_TYPES.reduce((acc, type, i) => {
        const r = results[i];
        if (r.status === "fulfilled") acc[type] = r.value?.[type] || "";
        return acc;
      }, {});
    },
    staleTime: QUERY_CONFIG.STALE_TIME_INFINITE,
    cacheTime: QUERY_CONFIG.STALE_TIME_INFINITE,
    refetchOnWindowFocus: false,
    ...options,
  });

export default useSiteConfig;
